

// //always start at the top of the page
// if ('scrollRestoration' in history) {
//   history.scrollRestoration = 'manual';
// }
// document.addEventListener("DOMContentLoaded", function() {
// setTimeout(function() {
//     window.scrollTo(0, 0);
//   }, 0);
// });

// Variant helpers (Size + Caffeine)
var circadianVariants = (window.circadianProduct && window.circadianProduct.variants) ? window.circadianProduct.variants : [];
var boxSetVariantId = window.circadianBoxSetVariantId || null;
window.selected_variant = window.selected_variant || null;
window.isBoxSetSelected = false;
window.isCustomCaffeineSelected = false;

function getPrettyPrice(priceCents){
    var dollars = priceCents / 100.0;
    return (dollars % 1 !== 0) ? dollars.toFixed(2) : dollars.toFixed(0);
}

function chooseDefaultVariant(){
    if (!circadianVariants || !circadianVariants.length) return null;
    var match = circadianVariants.find(function(v){ return v.available; });
    return match || circadianVariants[0];
}

function syncOptionSelects(variant){
    if (!variant) return;
    $("#size-select, #size-select-mobile").val(variant.option1);
    $("#caffeine-select, #caffeine-select-mobile").val(variant.option2);
}

function toggleCaffeinePicker(isBoxSet){
    var caffeinePickers = $(".option-pickers").filter(function(){
        return $(this).find("#caffeine-select, #caffeine-select-mobile").length > 0;
    });
    if (isBoxSet) {
        caffeinePickers.hide();
    } else {
        caffeinePickers.show();
    }
}

function updatePriceDisplays(){
    if (!window.selected_variant) return;
    var symbol = window.circadianCurrencySymbol || "$";
    var qty_input = $(".atc-right .qty-selector .qty-val").first();
    var raw_qty = qty_input.is("input, textarea, select") ? qty_input.val() : qty_input.text();
    var quantity = parseInt(String(raw_qty == null ? "" : raw_qty).replace(/\D/g, ""), 10);
    if (isNaN(quantity) || quantity < 1) quantity = 1;
    
    // Use Box Set price if Box Set is selected, otherwise use regular variant price
    var basePrice = window.isBoxSetSelected && window.circadianBoxSetPrice 
        ? window.circadianBoxSetPrice 
        : window.selected_variant.price;
    basePrice *= quantity;
    var subPrice = basePrice * 0.95;

    $(".atc-price").text(symbol + getPrettyPrice(basePrice));
    $(".sub-atc-price").text(symbol + getPrettyPrice(subPrice));

    var mobileSubVal = $("#subscribe-selector-mobile").val();
    if (mobileSubVal && mobileSubVal !== "one-time" && mobileSubVal !== "") {
        $(".mobile-only .atc-price").text(symbol + getPrettyPrice(subPrice));
    } else {
        $(".mobile-only .atc-price").text(symbol + getPrettyPrice(basePrice));
    }
}

function applyVariantSelection(variant, options){
    if (!variant) return;
    window.selected_variant = variant;
    $("#variant-select, #variant-select-mobile").val(String(variant.id));
    if (options && options.syncOptions) {
        syncOptionSelects(variant);
    }
    updatePriceDisplays();
}

function updateVariantURL(){
    if (typeof set_query_variable !== "function") return;
    if (window.isBoxSetSelected) {
        set_query_variable("variant", "box-set");
    } else if (window.isCustomCaffeineSelected) {
        return;
    } else if (window.selected_variant) {
        set_query_variable("variant", window.selected_variant.id);
    }
}

function findVariantByOptions(size, caffeine){
    if (!circadianVariants || !circadianVariants.length) return null;
    return circadianVariants.find(function(v){
        return String(v.option1) === String(size) && String(v.option2) === String(caffeine);
    }) || null;
}

function updateVariantFromOptions(isMobile){
    var sizeVal = isMobile ? $("#size-select-mobile").val() : $("#size-select").val();
    var caffeineVal = isMobile ? $("#caffeine-select-mobile").val() : $("#caffeine-select").val();
    
    // Check if Custom caffeine is selected
    if (caffeineVal === "Custom") {
        window.isCustomCaffeineSelected = true;
        $(".atc-button").addClass("custom-caffeine-selected");
    } else {
        window.isCustomCaffeineSelected = false;
        $(".atc-button").removeClass("custom-caffeine-selected");
    }
    
    if (sizeVal === "Box Set") {
        window.isBoxSetSelected = true;
        toggleCaffeinePicker(true);
        // Use first available variant for pricing display, but we'll use boxSetVariantId for ATC
        var variant = chooseDefaultVariant();
        if (variant) {
            applyVariantSelection(variant, {syncOptions:false});
        }
    } else {
        window.isBoxSetSelected = false;
        toggleCaffeinePicker(false);
        
        // For Custom caffeine, find a variant with the selected size for pricing,
        // but don't sync options back (which would overwrite "Custom" with a real value)
        var variant = findVariantByOptions(sizeVal, caffeineVal);
        if (!variant && caffeineVal === "Custom") {
            // Custom isn't a real variant option - find any variant with matching size for pricing
            variant = circadianVariants.find(function(v){ return String(v.option1) === String(sizeVal); });
        }
        variant = variant || chooseDefaultVariant();
        
        // Only sync options if NOT Custom caffeine (to preserve the Custom selection)
        applyVariantSelection(variant, {syncOptions: caffeineVal !== "Custom"});
    }
    updateVariantURL();
}

function handleVariantSelectChange(rawVal){
    if (!rawVal) return;
    if (rawVal === "byob") {
        applyVariantSelection(chooseDefaultVariant(), {syncOptions:false});
        return;
    }
    var variant = circadianVariants.find(function(v){ return String(v.id) === String(rawVal); });
    if (variant) {
        applyVariantSelection(variant, {syncOptions:true});
    }
}

function initializeCircadianVariants(){
    if (!circadianVariants.length) return;

    // Hide caffeine picker by default since Box Set is default
    toggleCaffeinePicker(true);

    $("#size-select, #caffeine-select").on("change", function(){
        var isCustomSelected = ($(this).attr('id') === 'caffeine-select' && $(this).val() === 'Custom');
        updateVariantFromOptions(false);
        
        // Scroll to calculator if Custom caffeine was selected
        if (isCustomSelected) {
            var calculatorSection = document.querySelector('.calculator');
            if (calculatorSection) {
setTimeout(function() {
                    calculatorSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 100);
            }
        }
    });
    $("#size-select-mobile, #caffeine-select-mobile").on("change", function(){
        var isCustomSelected = ($(this).attr('id') === 'caffeine-select-mobile' && $(this).val() === 'Custom');
        updateVariantFromOptions(true);
        
        // Scroll to calculator if Custom caffeine was selected
        if (isCustomSelected) {
            var calculatorSection = document.querySelector('.calculator');
            if (calculatorSection) {
                setTimeout(function() {
                    calculatorSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 100);
            }
        }
    });

    $("#variant-select, #variant-select-mobile").on("change", function(){
        handleVariantSelectChange($(this).val());
    });

    $("#subscribe-selector, #subscribe-selector-mobile").on("change", function(){
        updatePriceDisplays();
    });

    var initialVariant = null;
    var hasURLPreselect = false;
    var isBoxSetPreselect = false;
    if (typeof get_query_variable === "function") {
        var preselected = get_query_variable("variant");
        if (preselected) {
            if (preselected === "box-set") {
                isBoxSetPreselect = true;
                hasURLPreselect = true;
            } else {
                initialVariant = circadianVariants.find(function(v){ return String(v.id) === String(preselected); }) || null;
                hasURLPreselect = !!initialVariant;
            }
        }
    }
    if (!initialVariant) {
        initialVariant = chooseDefaultVariant();
    }

    applyVariantSelection(initialVariant, {syncOptions: hasURLPreselect && !isBoxSetPreselect});
    
    if (!hasURLPreselect || isBoxSetPreselect) {
        // Box Set is the default, or was explicitly deep-linked
        $("#size-select, #size-select-mobile").val("Box Set");
        window.isBoxSetSelected = true;
        toggleCaffeinePicker(true);
        
        $("#caffeine-select, #caffeine-select-mobile").val("75%");
        
        updatePriceDisplays();
    } else {
        // A specific variant was deep-linked — show the caffeine picker
        window.isBoxSetSelected = false;
        toggleCaffeinePicker(false);
    }
}




$(function(){

    window.scrolltied = new ScrollTide({nomarkers: true});


    setup_scrollties()

    setup_feat_prod_swiper()

    setup_misc_click_handlers()

    // Load state from URL before displaying chart
    loadStateFromURL();
    
    // Initialize cups display value
    var initialCups = parseInt($("#cups-per-day").val()) || 5;
    $("#cups-display").text(initialCups);
    
    // If URL parameters exist, scroll to calculator section
    var urlParams = new URLSearchParams(window.location.search);
    // Check for any calculator state parameters
    var calculatorParams = ['wakeup', 'cups', 'sleep', 'metabolism', 'extractionMethod', 'drinks'];
    var hasURLParams = calculatorParams.some(function(key) {
        return urlParams.has(key);
    });
    
    // Show advanced options if any advanced parameters are in URL
    var advancedParams = ['wakeup', 'sleep', 'metabolism', 'extractionMethod'];
    var hasAdvancedParams = advancedParams.some(function(key) {
        return urlParams.has(key);
    });
    if (hasAdvancedParams) {
        $("#advanced-options").show();
        window.cupDraggingEnabled = true;
    }
    
    // Initialize dragging state - enabled by default
    if (!hasAdvancedParams) {
        window.cupDraggingEnabled = false;
    }

    // Initialize variant selectors (Size + Caffeine)
    initializeCircadianVariants();
    
    if (hasURLParams) {
        // Select byob option when loading pre-baked rhythm from URL
        selectByobOption();
        
        var calculatorSection = document.querySelector('.calculator');
        if (calculatorSection) {
            // Use setTimeout to ensure page is fully loaded before scrolling
            setTimeout(function() {
                calculatorSection.scrollIntoView({ behavior: 'auto', block: 'start' });
            }, 100);
        }
    }

    display_chart_chartjs()
    
    // Force a post-render refresh so datasets match current inputs on first load
    setTimeout(function(){
        update_calculator();
        if (window.circChart) {
            re_render_chart();
        }
    }, 0);
    
})





window.atc_clicks = 0
window.atc_error = false

function set_global_atc_quantity(value, allow_blank){
    var qty_selector = $(".atc-right .qty-selector").first()
    var qty_input = qty_selector.find(".qty-val").first()
    var min = parseInt(qty_selector.attr("data-min"), 10)
    var max = parseInt(qty_selector.attr("data-max"), 10)
    var clean_value = String(value == null ? "" : value).replace(/\D/g, "")

    if (isNaN(min) || min < 1) min = 1
    if (isNaN(max) || max < min) max = 999
    if (max > 999) max = 999
    if (allow_blank && clean_value == "") {
        if (qty_input.is("input, textarea, select")) qty_input.val("")
        else qty_input.text("")
        return ""
    }

    var qty = parseInt(clean_value, 10)
    if (isNaN(qty) || qty < min) qty = min
    if (qty > max) qty = max

    if (qty_input.is("input, textarea, select")) qty_input.val(qty)
    else qty_input.text(qty)

    return qty
}

window.get_global_atc_quantity = function(){
    var qty_input = $(".atc-right .qty-selector .qty-val").first()
    var qty_value = qty_input.is("input, textarea, select") ? qty_input.val() : qty_input.text()
    return set_global_atc_quantity(qty_value, false)
}

$(function(){
    set_global_atc_quantity(window.get_global_atc_quantity(), false)

    $(".atc-right .qty-val").on("input", function(){
        var qty_value = $(this).is("input, textarea, select") ? $(this).val() : $(this).text()
        set_global_atc_quantity(qty_value, true)
        updatePriceDisplays()
    })

    $(".atc-right .qty-val").on("change blur", function(){
        var qty_value = $(this).is("input, textarea, select") ? $(this).val() : $(this).text()
        set_global_atc_quantity(qty_value, false)
        updatePriceDisplays()
    })

    $(".atc-right .qty-up").click(function(){
        set_global_atc_quantity(window.get_global_atc_quantity() + 1, false)
        updatePriceDisplays()
    })

    $(".atc-right .qty-down").click(function(){
        set_global_atc_quantity(window.get_global_atc_quantity() - 1, false)
        updatePriceDisplays()
    })
})

// Function to select "byob" option and add class to atc-button
function selectByobOption(suppressScroll) {
    // Flag to prevent scrolling when programmatically setting the value
    window.suppressVariantScroll = suppressScroll || false;
    
    // Select "byob" in desktop variant selector
    var desktopSelector = $("#variant-select");
    if (desktopSelector.length) {
        desktopSelector.val("byob").trigger('change');
    }
    
    // Select "byob" in mobile variant selector (if it exists)
    var mobileSelector = $("#variant-select-mobile");
    if (mobileSelector.length) {
        mobileSelector.val("byob").trigger('change');
    }
    
    // Add class to atc-button elements
    $(".atc-button").addClass("byob-selected");
    
    // Reset flag after a short delay
    setTimeout(function() {
        window.suppressVariantScroll = false;
    }, 200);
}

// Function to select "Custom" caffeine when calculator is interacted with
function selectCustomCaffeine() {
    window.isCustomCaffeineSelected = true;
    
    // Select "Custom" in desktop caffeine selector
    $("#caffeine-select").val("Custom");
    
    // Select "Custom" in mobile caffeine selector
    $("#caffeine-select-mobile").val("Custom");
    
    // Add visual indicator class to ATC buttons
    $(".atc-button").addClass("custom-caffeine-selected");
}

// Helper function to add multiple variants to cart sequentially
function addMultipleVariantsToCart(variantsToAdd, atcOptions, callbacks) {
    if (!variantsToAdd || variantsToAdd.length === 0) {
        if (callbacks.error) callbacks.error(new Error("No variants to add"));
        return;
    }
    
    var successfulItems = [];
    var currentIndex = 0;
    
    function addNext() {
        if (currentIndex >= variantsToAdd.length) {
            // All items added successfully
            if (callbacks.success) callbacks.success(successfulItems);
            return;
        }
        
        var item = variantsToAdd[currentIndex];
        currentIndex++;
        
        // Merge item-specific properties with global atcOptions
        var itemOptions = Object.assign({}, atcOptions);
        if (item.properties) {
            itemOptions.properties = item.properties;
        }
        
        CartJS.addItem(item.variantId, item.qty, itemOptions, {
            success: function(line_item) {
                successfulItems.push(line_item);
                addNext(); // Add the next variant
            },
            error: function(e) {
                console.error("Error adding variant to cart:", item, e);
                if (callbacks.error) callbacks.error(e);
            }
        });
    }
    
    addNext();
}

// ========================================
// CUSTOM CAFFEINE ADD-TO-CART HANDLER
// ========================================
// This function is called when adding to cart with "Custom" caffeine selected.
// Analyzes calculator state to determine which 8oz caffeine levels to add
// 
// Returns: {
//   variantsToAdd: array of {variantId, qty, properties} objects to add to cart
//   customData: object containing calculator state
// }
function handleCustomCaffeineAddToCart() {
    // Build custom caffeine data from calculator state
    var customData = {
        drinks: window.circ_config ? window.circ_config.drinks : [],
        wakeup: window.circ_wakeup || 420,
        sleep: window.circ_sleep || 1320,
        metabolism: $("#metabolism").val() || "average",
        extractionMethod: $("#extraction-method").val() || "drip",
        cupsPerDay: parseInt($("#cups-per-day").val()) || 5
    };
    
    // Format schedule for cart properties
    var scheduleData = {
        drinks: customData.drinks.map(function(drink) {
            return {
                time: drink.time,
                mg: drink.mg,
                label: getCaffeineLabel(drink.mg)
            };
        }),
        wakeup: customData.wakeup,
        sleep: customData.sleep,
        metabolism: customData.metabolism,
        extractionMethod: customData.extractionMethod,
        cupsPerDay: customData.cupsPerDay
    };
    
    // Convert to JSON string for cart property
    var scheduleJSON = JSON.stringify(scheduleData);
    
    // Extract caffeine levels from calculator drinks and count how many of each
    var caffeineCounts = {}; // Map of caffeine label -> count
    
    if (customData.drinks && customData.drinks.length > 0) {
        customData.drinks.forEach(function(drink) {
            var label = getCaffeineLabel(drink.mg);
            caffeineCounts[label] = (caffeineCounts[label] || 0) + 1;
        });
    }
    
    // Find 8oz variants for each caffeine level
    var variantsToAdd = [];
    
    for (var caffeineLevel in caffeineCounts) {
        if (caffeineCounts.hasOwnProperty(caffeineLevel)) {
            // Find the 8oz variant for this caffeine level
            var variant = findVariantByOptions("8oz", caffeineLevel);
            
            if (variant && variant.id) {
                variantsToAdd.push({
                    variantId: variant.id,
                    qty: caffeineCounts[caffeineLevel],
                    properties: {
                        '_circadian_schedule': scheduleJSON,
                        '_circadian_custom': 'true'
                    }
                });
            } else {
                console.warn("Could not find 8oz variant for caffeine level:", caffeineLevel);
            }
        }
    }
    
    console.log("Custom Caffeine ATC - Adding variants:", variantsToAdd);
    console.log("Calculator state:", customData);
    
    return {
        variantsToAdd: variantsToAdd,
        customData: customData
    };
}

function setup_misc_click_handlers(){

    // Scroll to calculator when "Custom" (byob) is selected (only if not suppressed)
    $("#variant-select, #variant-select-mobile").on("change", function(){
        // Don't scroll if this was triggered programmatically from calculator changes
        if (window.suppressVariantScroll) {
            return;
        }
        
        var selectedValue = $(this).val();
        if (selectedValue === "byob") {
            var calculatorSection = document.querySelector('.calculator');
            if (calculatorSection) {
                setTimeout(function() {
                    calculatorSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 100);
            }
        }
    });

    // Cups per day +/- buttons
    $("#cups-decrease").on("click", function(){
        var currentCups = parseInt($("#cups-per-day").val()) || 5;
        if (currentCups > 2) {
            currentCups--;
            $("#cups-per-day").val(currentCups).trigger('change');
            $("#cups-display").text(currentCups);
        }
    });
    
    $("#cups-increase").on("click", function(){
        var currentCups = parseInt($("#cups-per-day").val()) || 5;
        if (currentCups < 5) {
            currentCups++;
            $("#cups-per-day").val(currentCups).trigger('change');
            $("#cups-display").text(currentCups);
        }
    });

    // Update display when cups change (for compatibility with existing code)
    $("#cups-per-day").on("change", function(){
        var cups = parseInt($(this).val()) || 5;
        $("#cups-display").text(cups);
    });

    // Set initial button text based on dragging state (before setting up click handler)
    if (window.cupDraggingEnabled) {
        $("#show-advanced").text("Collapse");
        $("#advanced-options").show();
        $(".chartDivOuter").addClass("show");
        $(".calculator-actions").addClass("show");
        } else {
        $("#show-advanced").text("Customize");
        $("#advanced-options").hide();
        // Chart and actions will be hidden on mobile by default CSS
    }
    
    // Enable/Disable Cup Dragging
    $("#show-advanced").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        
        window.cupDraggingEnabled = !window.cupDraggingEnabled;
        var button = $(this);
        
        if (window.cupDraggingEnabled) {
            button.text("Collapse");
            $("#advanced-options").slideDown(200);
            // Show chart and actions on mobile when customize is active
            $(".chartDivOuter").addClass("show");
            $(".calculator-actions").addClass("show");
            
            // If Box Set is selected, switch to 8oz with Custom caffeine
            if (window.isBoxSetSelected) {
                // Update all state flags first
                window.isBoxSetSelected = false;
                window.isCustomCaffeineSelected = true;
                
                // Set both dropdown values (no change triggers - we'll update once at the end)
                $("#size-select, #size-select-mobile").val("8oz");
                $("#caffeine-select, #caffeine-select-mobile").val("Custom");
                
                // Show caffeine picker
                toggleCaffeinePicker(false);
                
                // Update variant and price displays once with all values set
                updateVariantFromOptions(false);
                
                // Add visual indicator
                $(".atc-button").addClass("custom-caffeine-selected");
            }
        } else {
            button.text("Customize");
            $("#advanced-options").slideUp(200);
            // Hide chart and actions on mobile when collapsed
            $(".chartDivOuter").removeClass("show");
            $(".calculator-actions").removeClass("show");
        }
        
        // Update chart dataset to enable/disable dragging
        if (window.circChart && window.circChart.data && window.circChart.data.datasets) {
            var cupDataset = window.circChart.data.datasets[2];
            if (cupDataset) {
                // Disable dragData plugin when locked
                cupDataset.dragData = window.cupDraggingEnabled;
                // Set pointHitRadius to 0 when locked to prevent interaction
                cupDataset.pointHitRadius = window.cupDraggingEnabled ? 60 : 0;
                // Update the chart to apply changes
                window.circChart.update('none');
            }
        }
        
        // Re-render tooltips and indicators to show/hide drag indicators
        if (window.circChart) {
            requestAnimationFrame(function() {
                renderCupTooltips();
            });
        }
    });
    


    // Save chart button - downloads chart as PNG with black background
    $("#save-chart").on("click", function(){
        if (!window.circChart) return;
        
        var chart = window.circChart;
        var canvas = chart.canvas;
        
        // Get the chart container to capture the full area including tooltips
        var chartContainer = document.getElementById('chartdiv');
        if (!chartContainer) return;
        
        try {
            // Create a new canvas with black background
            var exportCanvas = document.createElement('canvas');
            exportCanvas.width = canvas.width;
            exportCanvas.height = canvas.height;
            var ctx = exportCanvas.getContext('2d');
            
            // Fill with black background
            ctx.fillStyle = '#000000';
            ctx.fillRect(0, 0, exportCanvas.width, exportCanvas.height);
            
            // Draw the chart canvas on top of the black background
            ctx.drawImage(canvas, 0, 0);
            
            // Get the data URL from the new canvas
            var dataURL = exportCanvas.toDataURL('image/png');
            
            // Create a download link
            var link = document.createElement('a');
            link.download = 'circadian-rhythm-' + new Date().getTime() + '.png';
            link.href = dataURL;
            
            // Trigger download
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error saving chart:', error);
            alert('Unable to save chart. Please try again.');
        }
    });

    // Share button - uses native Web Share API with clipboard fallback
    $("#share-rhythm").on("click", function(){
        var shareButton = $(this);
        var currentURL = window.location.href;
        
        // Ensure URL is up to date with current state
        saveStateToURL();
        currentURL = window.location.href;
        
        // Try native Web Share API first (mobile/desktop with share support)
        if (navigator.share) {
            navigator.share({
                title: 'My Circadian Rhythm',
                text: 'Check out my custom circadian rhythm!',
                url: currentURL
            }).then(function() {
                // Share successful
                var originalText = shareButton.text();
                shareButton.text('Shared!');
                setTimeout(function() {
                    shareButton.text(originalText);
                }, 2000);
            }).catch(function(error) {
                // User cancelled or error occurred
                if (error.name !== 'AbortError') {
                    // Only show error if it wasn't a cancellation
                    fallbackToClipboard(shareButton, currentURL);
                }
            });
        } else {
            // Fallback to clipboard
            fallbackToClipboard(shareButton, currentURL);
        }
    });
    
    // Fallback function to copy URL to clipboard
    function fallbackToClipboard(button, url) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(function() {
                var originalText = button.text();
                button.text('Copied!');
                setTimeout(function() {
                    button.text(originalText);
                }, 2000);
            }).catch(function() {
                // Clipboard API failed, try older method
                copyToClipboardFallback(button, url);
            });
        } else {
            // Use older clipboard method
            copyToClipboardFallback(button, url);
        }
    }
    
    // Older fallback method for copying to clipboard
    function copyToClipboardFallback(button, url) {
        var textArea = document.createElement('textarea');
        textArea.value = url;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        try {
            var successful = document.execCommand('copy');
            if (successful) {
                var originalText = button.text();
                button.text('Copied!');
                setTimeout(function() {
                    button.text(originalText);
                }, 2000);
            } else {
                // Show URL in alert as last resort
                alert('Copy this URL to share:\n\n' + url);
            }
        } catch (err) {
            // Show URL in alert as last resort
            alert('Copy this URL to share:\n\n' + url);
        } finally {
            document.body.removeChild(textArea);
        }
    }
    
    // Buy this Routine button - adds custom caffeine schedule to cart
    $(".calculator-actions .atc").on("click", function(){
        var button = $(this);
        var originalText = button.text();
        
        button.text("Adding...");
        button.prop('disabled', true);
        
        // Get custom caffeine result
        var customResult = handleCustomCaffeineAddToCart();
        
        if (!customResult || !customResult.variantsToAdd || customResult.variantsToAdd.length === 0) {
            button.text("Error :(");
            button.prop('disabled', false);
            setTimeout(function() {
                button.text(originalText);
            }, 2000);
            return;
        }
        
        // Add all variants to cart
        addMultipleVariantsToCart(customResult.variantsToAdd, {}, {
            success: function(line_items) {
                if (line_items.length > 0) {
                    show_cart_confirm(line_items[0]);
                }
                $("header .cart-count").show()
                button.text("Added!");
                button.prop('disabled', false);
                setTimeout(function() {
                    button.text(originalText);
                }, 2000);
            },
            error: function(e){
                console.error("Error adding custom routine to cart:", e);
                button.text("Error :(");
                button.prop('disabled', false);
                setTimeout(function() {
                    button.text(originalText);
                }, 2000);
            }
        });
    });

    $("#wakeup-time").on("change", function(){
        update_calculator();
        re_render_chart();
        saveStateToURL();
        selectByobOption(true); // Suppress scroll when triggered by calculator changes
        selectCustomCaffeine(); // Mark caffeine as custom
    });
    $("#cups-per-day")
        .on("keyup", function(){
            update_calculator();
            re_render_chart();
            saveStateToURL();
            selectByobOption(true); // Suppress scroll when triggered by calculator changes
            selectCustomCaffeine(); // Mark caffeine as custom
        })
        .on("change", function(){
            var cups = parseInt($(this).val()) || 5;
            $("#cups-display").text(cups);
            update_calculator();
            re_render_chart();
            saveStateToURL();
            selectByobOption(true); // Suppress scroll when triggered by calculator changes
            selectCustomCaffeine(); // Mark caffeine as custom
        });
    $("#sleep-time").on("change", function(){
        update_calculator();
        re_render_chart();
        saveStateToURL();
        selectByobOption(true); // Suppress scroll when triggered by calculator changes
        selectCustomCaffeine(); // Mark caffeine as custom
    });
    
    // Metabolism selector
    $("#metabolism").on("change", function(){
        update_calculator();
        re_render_chart();
        saveStateToURL();
        selectByobOption(true); // Suppress scroll when triggered by calculator changes
        selectCustomCaffeine(); // Mark caffeine as custom
    });
    
    // Extraction method selector
    $("#extraction-method").on("change", function(){
        update_calculator();
        re_render_chart();
        saveStateToURL();
        selectByobOption(true); // Suppress scroll when triggered by calculator changes
        selectCustomCaffeine(); // Mark caffeine as custom
    });



    // State object for blob rotation animations
    window.blob_rot_state = {
        currentValue: 0,
        animeInstance: null,
        isAnimatingFromButton: false, // Flag to prevent progress event interference
        isUserDragging: false // Track when user is actively touching/dragging
    };

    $(".caff-sel .btn").click(function(){
        var this_hover = $(this).attr("data-hov")
        $(".caff-sel").attr("data-hov", this_hover)

        var this_index = parseInt($(this).attr("data-index"))

        // Animate blob_rot when clicking navigation buttons
        if (window.deets_swiper && typeof anime !== "undefined") {
            var totalSlides = window.deets_swiper.slides.length;
            var targetProgress = totalSlides > 1 ? this_index / (totalSlides - 1) : 0;
            var targetBlobRot = -288 * targetProgress;
            
            // Cancel any existing animation
            if (window.blob_rot_state.animeInstance) {
                window.blob_rot_state.animeInstance.pause();
            }
            
            // Set flag to prevent progress event interference
            window.blob_rot_state.isAnimatingFromButton = true;
            
            // Animate blob_rot to target value
            window.blob_rot_state.animeInstance = anime({
                targets: window.blob_rot_state,
                currentValue: targetBlobRot,
                duration: 1200,
                easing: 'easeInOutCubic',
                update: function() {
                    queueSpline(function(){
                        window.splineblob.setVariable("blob_rot", window.blob_rot_state.currentValue);
                    });
                },
                complete: function() {
                    // Animation done - allow progress events again
                    window.blob_rot_state.isAnimatingFromButton = false;
                }
            });
        }

        deets_swiper.slideTo(this_index)
        //find the right swiper index for the box set
        
    })


    window.deets_swiper = new Swiper('.deets-slider', {
      slidesPerView: 1,
        loop: false,
        spaceBetween: 20,
        speed: 400,
      
      on: {
        slideChange: function() {
          // Update .caff-sel state to match the active slide
          var activeIndex = this.realIndex; // Use realIndex for looped swipers
          $(".caff-sel").attr("data-hov", "hov-" + activeIndex);
        },
        
        // ========================================
        // SWIPER ANIMATION HOOKS
        // Use these to lerp/animate other elements during swipe
        // ========================================
        touchStart: function(swiper, event) {
            // User started touching - pause any animations and mark as dragging
            if (window.blob_rot_state) {
                if (window.blob_rot_state.animeInstance) {
                    window.blob_rot_state.animeInstance.pause();
                }
                window.blob_rot_state.isAnimatingFromButton = false;
                window.blob_rot_state.isUserDragging = true;
            }
        },
        
        touchEnd: function(swiper, event) {
            // User released touch - no longer dragging
            if (window.blob_rot_state) {
                window.blob_rot_state.isUserDragging = false;
            }
        },
        
        transitionStart: function(swiper) {
            // Transition started - lerp from current position to target
            // Only animate if NOT already animating from button
            if (window.blob_rot_state && !window.blob_rot_state.isAnimatingFromButton && typeof anime !== "undefined") {
                // Calculate target blob_rot based on target slide
                var targetIndex = swiper.activeIndex;
                var totalSlides = swiper.slides.length;
                var targetProgress = totalSlides > 1 ? targetIndex / (totalSlides - 1) : 0;
                var targetBlobRot = -288 * targetProgress;
                
                // Cancel any existing animation
                if (window.blob_rot_state.animeInstance) {
                    window.blob_rot_state.animeInstance.pause();
                }
                
                // Animate from CURRENT position to target
                window.blob_rot_state.animeInstance = anime({
                    targets: window.blob_rot_state,
                    currentValue: targetBlobRot,
                    duration: swiper.params.speed || 400,
                    easing: 'easeOutCubic',
                    update: function() {
                        queueSpline(function(){
                            window.splineblob.setVariable("blob_rot", window.blob_rot_state.currentValue);
                        });
                    }
                });
            }
        },
        
        setTranslate: function(swiper,translate){

        },
        progress: function(swiper, progress) {
            // Only update during actual user dragging (not during animations)
            if (!window.blob_rot_state) return;
            
            // Skip if animating from button click
            if (window.blob_rot_state.isAnimatingFromButton) return;
            
            // Skip if NOT dragging (means we're in momentum/transition)
            if (!window.blob_rot_state.isUserDragging) return;
            
            var mapped_prog = -288 * progress
            
            // Update state and spline during drag
            window.blob_rot_state.currentValue = mapped_prog;

            queueSpline(function(){
                window.splineblob.setVariable("blob_rot", mapped_prog)
            })

        }
      }

    });



    



    //ATC - desktop (non-subscribe)
    $(".atc-button.desktop-only").click(function(){


        var that = $(this)

        window.atc_clicks++

        var already_did = false
        if (that.html() == "Going..." || that.html() == "You did it!" || that.html() == "Again, again!!"){
            already_did = true
        }

        that.html("Going...")


        // Handle Custom Caffeine selection - add multiple 8oz variants
        if (window.isCustomCaffeineSelected) {
            var customResult = handleCustomCaffeineAddToCart();
            
            if (customResult && customResult.variantsToAdd && customResult.variantsToAdd.length > 0) {
                addMultipleVariantsToCart(customResult.variantsToAdd, {}, {
                    success: function(line_items) {
                        // Show confirmation with first item (or could aggregate)
                        if (line_items.length > 0) {
                            show_cart_confirm(line_items[0]);
                        }
                        $("header .cart-count").show()
                        if (already_did){
                            if (window.atc_clicks > 3){
                                that.html("Hehe, it tickles... 🤮")
                            }
                            else {
                                that.html("Again, again!!")
                            }
                        }
                        else {
                            that.html("You did it!")
                        }
                    },
                    error: function(e){
                        if (window.atc_error){
                            that.html("Please call us...")
                            window.atc_error = false
                        }
                        else {
                            window.atc_error = true
                            that.html("Error! :(")
                        }
                        console.log(e)
                    }
                });
                return;
            }
        }
        
        // Standard single variant add to cart
        var id = window.isBoxSetSelected && boxSetVariantId ? boxSetVariantId : window.selected_variant.id;
        var qty = window.get_global_atc_quantity ? window.get_global_atc_quantity() : 1

        CartJS.addItem(id,qty, {}, {
            "success":function(line_item, msg){
                show_cart_confirm(line_item)
                $("header .cart-count").show()
                if (already_did){
                    if (window.atc_clicks > 3){
                        that.html("Hehe, it tickles... 🤮")
                    }
                    else {
                        that.html("Again, again!!")
                    }
                    
                }
                else {
                    that.html("You did it!")
                }
                
            },
            "error":function(e){
                if (window.atc_error){
                    that.html("Please call us...")
                    window.atc_error = false
                }
                else {
                    window.atc_error = true
                    that.html("Error! :(")
                }
                
                console.log(e)
                //alert("We weren't able to add t")
            }
        });


        //get qty
        //get variant id

        //SEND IT, BRUH
    })

    //ATC - mobile (dual mode both one-time and subscription)
    $(".atc-button.mobile-only").click(function(){
        
        var that = $(this)

        var atc_options = {}
        var sub_id = $("#subscribe-selector-mobile").find(':selected').attr('data-id');

        var freq_num = $("#subscribe-selector-mobile").val()
        if (freq_num == "bottomless"){
            //show popup
            open_bottomless()
            return
        }
        if (freq_num != "one-time"){
            atc_options = {
                shipping_interval_frequency:freq_num,
                selling_plan:parseInt(sub_id)
            }
        }

        that.html("Going...")

        // Handle Custom Caffeine selection - add multiple 8oz variants
        if (window.isCustomCaffeineSelected) {
            var customResult = handleCustomCaffeineAddToCart();
            
            if (customResult && customResult.variantsToAdd && customResult.variantsToAdd.length > 0) {
                addMultipleVariantsToCart(customResult.variantsToAdd, atc_options, {
                    success: function(line_items) {
                        if (line_items.length > 0) {
                            show_cart_confirm(line_items[0]);
                        }
                        $("header .cart-count").show()
                        that.html("Added!")
                    },
                    error: function(e){
                        console.log(e)
                        that.html("Error :(")
                    }
                });
                return;
            }
        }

        // Standard single variant add to cart
        var id = window.isBoxSetSelected && boxSetVariantId ? boxSetVariantId : window.selected_variant.id;
        var qty = window.get_global_atc_quantity ? window.get_global_atc_quantity() : 1

        CartJS.addItem(id,qty, atc_options, {
            "success":function(line_item){
            show_cart_confirm(line_item)
                $("header .cart-count").show()
                that.html("Added!")
            },
            "error":function(e){
                //console.log(e)
                that.html("Error :(")
            }
        });

    })

    $(".trans-learn-more").click(function(){
        $(".coffee-modal.active").removeClass("active")
        var this_id = $(this).attr("data-id")
        $("html").addClass("stuck")
        $("#" + this_id).addClass("active")
    })

    // Info icons in advanced options (metabolism / extraction)
    $(".info-icon").on("click", function(){
        var modalId = $(this).attr("data-modal");
        if (!modalId) return;
        $(".coffee-modal.active").removeClass("active");
        $("html").addClass("stuck");
        $("#" + modalId).addClass("active");
    });


    $(".trans-virtue").click(function(){
        $(".coffee-modal.active").removeClass("active")
        var this_id = $(this).attr("data-id")
        $("html").addClass("stuck")
        $("#" + this_id).addClass("active")
    })

    $(".testing .trans-tab").click(function(){
        
        var active_tab = $(".testing .trans-tab.active")
        var active_video = active_tab.find(".trans-img video")[0]
        if (active_video)
            active_video.pause()

        $(".testing .trans-tab.active").removeClass("active")
        
        
        var new_video = $(this).find(".trans-img video")[0]
        $(this).addClass("active")

        //if (window.innerWidth < 800)
            //$(this)[0].scrollIntoView({ behavior: "smooth" }); 

        if (!new_video) return
        new_video.play()
        

    })


    $(".fin-trans .trans-tab").click(function(){
        
        var active_tab = $(".fin-trans .trans-tab.active")
        var active_video = active_tab.find(".trans-img video")[0]
        if (active_video)
            active_video.pause()

        $(".fin-trans .trans-tab.active").removeClass("active")
        
        
        var new_video = $(this).find(".trans-img video")[0]
        $(this).addClass("active")

        //if (window.innerWidth < 800)
            //$(this)[0].scrollIntoView({ behavior: "smooth" }); 

        if (!new_video) return
        new_video.play()
        

    })


    $(".a-stat-desc .button").click(function(){
        $(".coffee-modal.active").removeClass("active")
        var this_id = $(this).attr("data-id")
        $("html").addClass("stuck")
        $("#" + this_id).addClass("active")
    })

    // //subscribe click
    // $(".subscribe-atc").click(function(){
    //     var that = $(this)
    //     that.html("One Sec...")

    //     var id = window.isBoxSetSelected && boxSetVariantId ? boxSetVariantId : window.selected_variant.id;
    //     var qty = window.get_global_atc_quantity ? window.get_global_atc_quantity() : 1
        
    //     // Handle Custom Caffeine selection
    //     if (window.isCustomCaffeineSelected) {
    //         var customResult = handleCustomCaffeineAddToCart();
    //         if (customResult && customResult.variantId) {
    //             id = customResult.variantId;
    //         }
    //     }

    //     var freq_num = $("#subscribe-selector").val()
    //     if (freq_num == "bottomless"){
    //         open_bottomless()
    //         //show popup
    //         return
    //     }

    //     var atc_options = {}
    //     var sub_id = $("#subscribe-selector").find(':selected').attr('data-id');
        

    //     atc_options = {
    //         shipping_interval_frequency:freq_num,
    //         selling_plan:parseInt(sub_id)
    //     }

    //     console.log(atc_options)

    //     CartJS.addItem(id,qty, atc_options, {
    //         "success":function(line_item){
    //         show_cart_confirm(line_item)
    //             $("header .cart-count").show()
    //         },
    //         "error":function(e){
    //             console.log(e)
    //             that.html("Error :(")
    //         }
    //     });

    // })



    //showing and hiding the story popup
    $(".story-more-trigger").click(function(){
        $("html").addClass("stuck")
        $("#story-more").addClass("active")
    })
    
    //generic modal closing
    $(".modal-close").click(function(){
        $("html").removeClass("stuck")
        $(".coffee-modal.active").removeClass("active")
    })

    //showing and hiding brew guides for espresso/filter and english/spanish
    $(".guides .lang-selector button").click(function(){
        $(".lang-selector button.active").removeClass("active")
        $(this).addClass("active")
        brew_video_display_check()
    })
    $(".guides .guide-selector button").click(function(){
        $(".guide-selector button.active").removeClass("active")
        $(this).addClass("active")
        brew_video_display_check()
    })
    
    // all-selector (used by brew_guide_blocks schema)
    $(".guides .all-selector button").click(function(){
        $(".all-selector button.active").removeClass("active")
        $(this).addClass("active")
        var this_id = $(this).attr("data-guide")
        $(".guide-body.active").removeClass("active")
        $(".guide-body[data-guide='"+this_id+"']").addClass("active")
        $(".brew-timer-container.active").removeClass("active")
        $(".brew-timer-container[data-guide='"+this_id+"']").addClass("active")
    })

    //addon products
    $(".add-addon").click(function(){
        var variant = parseInt($(this).attr("data-variant-id"))
        var that = $(this)
        that.html("Going...")
        CartJS.addItem(variant,1, {}, {
            "success":function(line_item){
                that.html("Done!")
                show_cart_confirm(line_item)
                },
            "error":function(){
                that.html("Error :(")
            }
        });

    })

    function brew_video_display_check() {
        const lang = $(".lang-selector button.active").attr("data-lang") || "en";

        // source of truth on load
        const guide =
            $(".guides .all-selector button.active").attr("data-guide") ||
            $(".guides .all-selector button").first().attr("data-guide");

        if (!guide) return;

        // --- guide body ---
        $(".guide-body.active").removeClass("active");

        // Prefer lang match if guide bodies have data-lang, otherwise fall back to guide-only
        const $byLang = $(`.guide-body[data-guide='${guide}'][data-lang='${lang}']`);
        const $byGuide = $(`.guide-body[data-guide='${guide}']`);

        ($byLang.length ? $byLang : $byGuide).addClass("active");

        // --- timer ---
        $(".brew-timer-container.active").removeClass("active");
        $(`.brew-timer-container[data-guide='${guide}']`).addClass("active");
    }

    $(function () {
    brew_video_display_check();
    });
}





function setup_feat_prod_swiper() {

    var feat_prod_swipers = document.querySelectorAll(".feat-prod-slider .swiper")
    for (var swip of feat_prod_swipers){
        const swiper = new Swiper(swip, {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 20,
            // observer: true, 
            // observeParents: true,
            mousewheel: true,
            // And if we need scrollbar
            scrollbar: {
                draggable: true,
                el: '.swiper-scrollbar',
            },
        });
    }

}



// Box Overview Section Swiper & Navigation
document.addEventListener("DOMContentLoaded", () => {
    const swiperEl = document.querySelector("[data-overview-swiper]");
    if (!swiperEl || typeof Swiper === "undefined") return;

    // scope everything to the closest section so we don't accidentally grab the wrong elements
    const root = swiperEl.closest(".box-overview") || swiperEl.parentElement || document;

    const nav    = root.querySelector("[data-overview-tabs]");
    const btns   = nav ? Array.from(nav.querySelectorAll("[data-tab-btn]")) : [];
    const labels = Array.from(root.querySelectorAll(".tab-labels .tab-label"));

    const overviewSwiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        initialSlide: 0,
        speed: 350,
        autoHeight: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        simulateTouch: true,
        grabCursor: true,
        touchStartPreventDefault: false,
        observer: true,
        observeParents: true,
        on: {
            init(swiper) {
                syncNav(swiper.activeIndex);
            },
            slideChange(swiper) {
                syncNav(swiper.activeIndex);
            },
        }
    });

    function syncNav(index) {
        // update CSS var (used for your pill indicator)
        if (nav) nav.style.setProperty("--active-index", index);

        // toggle button active state
        btns.forEach((btn) => {
        const i = Number(btn.dataset.index);
        const active = i === index;
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-selected", active ? "true" : "false");
        btn.toggleAttribute("disabled", active);
        });

        // toggle label active state
        labels.forEach((label) => {
        const i = Number(label.getAttribute("data-index"));
        label.classList.toggle("is-active", i === index);
        });
    }

    // clicking tabs moves swiper
    btns.forEach((btn) => {
        btn.addEventListener("click", () => {
        const index = Number(btn.dataset.index);
        if (Number.isNaN(index)) return;
        overviewSwiper.slideTo(index);
        });
    });

    window.overviewSwiper = overviewSwiper; // optional
});


document.querySelectorAll("[data-overview-tabs]").forEach((nav) => {
    // initial
    syncLabels(nav);

    // whenever your code updates `style="--active-index: X;"`
    const mo = new MutationObserver(() => syncLabels(nav));
    mo.observe(nav, { attributes: true, attributeFilter: ["style"] });

    // optional: clicking a tab button should update shortly after
    nav.addEventListener("click", (e) => {
      if (e.target.closest("[data-tab-btn]")) requestAnimationFrame(() => syncLabels(nav));
    });
});

// TOGGLES FOR COFFEE_MODAL
(function ($) {
  // OPEN (delegated)
  $(document).on("click", ".coffee-modal-control", function (e) {
    e.preventDefault();

    const id = $(this).data("id") || $(this).data("modal");
    if (!id) return;

    $(".coffee-modal.active").removeClass("active");
    $("html").addClass("stuck");
    $("#" + id).addClass("active");
  });

  // CLOSE (delegated)
  $(document).on("click", ".coffee-modal .modal-close", function (e) {
    e.preventDefault();
    $("html").removeClass("stuck");
    $(this).closest(".coffee-modal").removeClass("active");
  });
})(jQuery);



function ezinout(value) {
  // normalize input to 0–1
  let t = value / 100;

  // apply easing
  let eased = t < 0.5
    ? 4 * t * t * t
    : 1 - Math.pow(-2 * t + 2, 3) / 2;

  // map back to 0–100
  return eased * 100;
}


// Coalesce frequent spline updates to a single rAF tick
var splineOps = [];
var splineRafId = null;
function queueSpline(op){
    splineOps.push(op);
    if (!splineRafId){
        splineRafId = requestAnimationFrame(function(){
            var ops = splineOps;
            splineOps = [];
            splineRafId = null;
            for (var i=0; i<ops.length; i++){
                try { ops[i](); } catch(e) {}
            }
        });
    }
}


function setup_scrollties(){

    window.container_target = document.querySelector("main")
    window.body_target = document.querySelector("body")


    
    window.title_spacer = document.querySelector(".test-before") //lmao this should be renamed
    window.intro_spacer = document.querySelector("#hero-spacer")
    window.trans_spacer = document.querySelector("#transparency")
    window.story_spacer = document.querySelector("#story-spacer")
    window.guides_spacer = document.querySelector(".guides")

    // window.test_spacer = document.querySelector(".box-overview")
    



    //the big background circle rotations
    window.tickerz_offset = 0
    let tickerz = new Scroller({
        id:"tickerz",
        container:document.querySelector("main"),
        window_offset: 0.0,
        el_start: 0.0,
        el_end: 0.9,
        targets:[$(".sticky-cta")[0]],
        markers: false,
        onunstart: function(){
            window.splineblob.setVariable("tickerz", 0)
            //splineblob.setVariable("rotated", false)
        },
        oncomplete: function(){
            window.splineblob.setVariable("tickerz", 0)
            //splineblob.setVariable("rotated", true)
        },
        onprogress: function(prog){


            const mappedProg = (prog * 3)

            //console.log(mappedProg)
            if (window.tickerz_offset != mappedProg){
                queueSpline(function(){
                    window.splineblob.setVariable("tickerz", mappedProg)
                    window.splineblob.setVariable("tickerzminus", -mappedProg)
                })
                //
                //window.splineblob.setVariable("blob_rot", mappedProg*2)
            }
                

            window.tickerz_offset = mappedProg
        }
    })
    scrolltied.add(tickerz)




    //intro fade out and rotate blob
    window.blob_1_matcap_val = 0
    let blob_1_matcap = new Scroller({
        id:"blob_1_matcap",
        container:document.querySelector(".hero-main"),
        window_offset: 0.05,
        el_start: 0.0,
        el_end: 0.9,
        targets:[$(".sticky-cta")[0]],
        markers: false,
        onunstart: function(){
            window.splineblob.setVariable("blob_1_matcap", 100)
            //splineblob.setVariable("rotated", false)
        },
        oncomplete: function(){
            window.splineblob.setVariable("blob_1_matcap", 0)
            //splineblob.setVariable("rotated", true)
        },
        onprogress: function(prog){

            const remapped = 100 - prog
            const eased_prog = ezinout(remapped)
            const mappedProg = (eased_prog * 0.9)

            //console.log(mappedProg)
            if (window.blob_1_matcap_val != mappedProg){
                queueSpline(function(){
                    window.splineblob.setVariable("blob_1_matcap", mappedProg)
                })
                
            }
                
            window.blob_1_matcap_val = mappedProg
        }
    })
    scrolltied.add(blob_1_matcap)







    // Initialize intro swiper
    if (document.querySelector(".intro-swiper")) {
        window.intro_swiper = new Swiper('.intro-swiper', {
            slidesPerView: 1.2,
            spaceBetween: 32,
            centeredSlides: true,
            loop: false,
            speed: 200,
            
            navigation: {
                nextEl: '.intro-swiper .swiper-button-next',
                prevEl: '.intro-swiper .swiper-button-prev',
            },
            
            pagination: {
                el: '.intro-swiper .swiper-pagination',
                clickable: true,
            },
            
            breakpoints: {
                768: {
                    spaceBetween: 32,
                },
                0: {
                    spaceBetween: 16,
                }
            }
        });
    }

    //fade back in the BLOB
    var sliderEl = document.querySelector(".circadian-intro-slider");
    window.explode_prog = 0
    let blob_explode = new Scroller({
        id:"blob_explode",
        container:sliderEl,
        window_offset: 0.5,
        el_start: 0.35,
        el_end: 0.48,
        targets:[$(".sticky-cta")[0]],
        markers: true,
        oncomplete: function(){
            queueSpline(function(){
                window.splineblob.setVariable("blob_1_matcap", 100)
            })
        },
        onunstart:function(){
            queueSpline(function(){
                window.splineblob.setVariable("blob_1_matcap", 0)
            })
        },
        onprogress: function(prog){

            if (window.explode_prog == prog){
                window.explode_prog = prog
                return;
            }
                
            // var remapped = 100 - prog
            const eased_prog = ezinout(prog)
            const mappedProg = (eased_prog * 0.9)

            //console.log(mappedProg)
            if (window.explode_prog != mappedProg){
                queueSpline(function(){
                    window.splineblob.setVariable("blob_1_matcap", mappedProg)
                })
            }
                
            window.explode_prog = mappedProg

        }
    })
    scrolltied.add(blob_explode)








    //blobs seperate
    let blobs_up_scroller = new Scroller({
        id:"blobs_up",
        container:document.querySelector(".box-details"),
        window_offset: 0.9,
        el_start: 0,
        el_end: 0.05,
        targets:[$(".sticky-cta")[0]],
        markers: true,
        onunstart: function(){

            queueSpline(function(){
                window.splineblob.setVariable("blob_rot", 0)
            })

            if (window.blob_2_obj){
                blob_2_obj.transition({ to: 'Base State', easing: 3 });
                blob_3_obj.transition({ to: 'Base State', easing: 3 });
                blob_4_obj.transition({ to: 'Base State', easing: 3 });
                blob_5_obj.transition({ to: 'Base State', easing: 3 });
            }
            // window.splineblob.setVariable("blob_group_y", -1537)
            // window.blobs_up = 0
        },
        oncomplete: function(){

            if (window.blob_2_obj){
                blob_2_obj.transition({ to: 'State', easing: 3 });
                blob_3_obj.transition({ to: 'State', easing: 3 });
                blob_4_obj.transition({ to: 'State', easing: 3 });
                blob_5_obj.transition({ to: 'State', easing: 3 });
            }
            // window.splineblob.setVariable("blob_group_y", 3018)
            // window.blobs_up = 100
        },
    })
    scrolltied.add(blobs_up_scroller)






  //Blobs go up during calculator page
    window.blob_outer_y_val = 0
    let blob_outer_y_anim = new Scroller({
        id:"blog_oy",
        container:document.querySelector(".guides"),
        window_offset: 0,
        el_start: 0.1,
        el_end: 0.98,
        targets:[$(".sticky-cta")[0]],
        markers: true,
        onunstart: function(){
            window.splineblob.setVariable("blob_outer_y", 0)
        },
        oncomplete: function(){
            window.splineblob.setVariable("blob_outer_y", 1400)
        },
        onprogress: function(prog){

            if (window.blob_outer_y_val == prog){
                window.blob_outer_y_val = prog
                return;
            }

            const tick_map =        (prog) => (prog / 100) * (1400);
            queueSpline(function(){
                window.splineblob.setVariable("blob_outer_y", tick_map(prog))
            })
            
            //do the swiper calls here?
                
            window.blob_outer_y_val = prog

        }
    })
    scrolltied.add(blob_outer_y_anim)





    //swisswater in + outtro
    window.swiss_z_val = 0
    let swiss_z = new Scroller({
        id:"swiss_z",
        container:document.querySelector(".story-bg"),
        window_offset: 0,
        el_start: 0.1,
        el_end: 0.98,
        targets:[$(".sticky-cta")[0]],
        markers: true,
        onunstart: function(){
            window.splineblob.setVariable("overall_tick_z", -1106)
        },
        oncomplete: function(){
            window.splineblob.setVariable("overall_tick_z", 1200)
        },
        onprogress: function(prog){

            if (window.swiss_z_val == prog){
                window.swiss_z_val = prog
                return;
            }

            const tick_map =        (prog) => (prog / 100) * (1200 - (-1106)) + (-1106);
            queueSpline(function(){
                window.splineblob.setVariable("overall_tick_z", tick_map(prog))
            })
            
            //do the swiper calls here?
                
            window.swiss_z_val = prog

        }
    })
    scrolltied.add(swiss_z)







    //swisswater in + outtro
    let swiss_up = new Scroller({
        id:"swiss_up",
        container:document.querySelector(".story-outer"),
        window_offset: 1,
        el_start: 0,
        el_end: 0.75,
        targets:[$(".sticky-cta")[0]],
        markers: true,
        onunstart: function(){
            window.splineblob.setVariable("blob_outer_y", 1800)
        },
        oncomplete: function(){
            window.splineblob.setVariable("blob_outer_y", 3100)
        },
        onprogress: function(prog){

            if (window.swiss_z_val == prog){
                window.swiss_z_val = prog
                return;
            }

            const tick_map = (prog) => (prog / 100) * (3100 - 1800) + 1800;
            queueSpline(function(){
                window.splineblob.setVariable("blob_outer_y", tick_map(prog))
            })
            
            //do the swiper calls here?
                
            window.swiss_z_val = prog

        }
    })
    scrolltied.add(swiss_up)







    //grid dots come forward
    window.all_out = 0
    let all_out = new Scroller({
        id:"swiss_z",
        container:document.querySelector(".story-bg"),
        window_offset: 0,
        el_start: 0.1,
        el_end: 1,
        targets:[$(".sticky-cta")[0]],
        markers: true,
        oncomplete: function(){
            queueSpline(function(){
                window.splineblob.setVariable("swiss_z", 1300)
            })
        },
        onunstart: function(){
            queueSpline(function(){
                window.splineblob.setVariable("swiss_z", -4400)
            })
        },
        onprogress: function(prog){

            if (window.all_out == prog){
                window.all_out = prog
                return;
            }
                
            const map0to100To1818 = (prog) => (prog / 100) * (1300 - (-4400)) + (-4400);
            
            const mapped = map0to100To1818(prog)
            
            
            //console.log(mapped_prog)
            queueSpline(function(){
                window.splineblob.setVariable("swiss_z", mapped)
            })



            //do the swiper calls here?
                

            window.all_out = prog

        }
    })
    scrolltied.add(all_out)






    //Swiss water comes forward
    window.swiss_out = 0
    let swiss_out_anim = new Scroller({
        id:"swiss_z",
        container:document.querySelector(".story-outer"),
        window_offset: 0.2,
        el_start: 0.8,
        el_end: 1,
        targets:[$(".sticky-cta")[0]],
        markers: true,
        oncomplete: function(){
            queueSpline(function(){
                window.splineblob.setVariable("swiss_z_opacity", 0)
            })
        },
        onprogress: function(prog){

            if (window.swiss_out == prog){
                window.swiss_out = prog
                return;
            }
            
            //console.log(mapped_prog)
            queueSpline(function(){
                window.splineblob.setVariable("swiss_z_opacity", 100 - prog)
            })



            //do the swiper calls here?
                

            window.swiss_out = prog

        }
    })
    scrolltied.add(swiss_out_anim)



    




    scrolltied.start()
    scrolltied.update()


    return







}





// Helper functions for discrete caffeine values
// Calculate caffeine levels based on extraction method (full caffeine value)
function getCaffeineLevels(fullMg) {
    var baseDecaf = 20;
    var range = fullMg - baseDecaf;
    return {
        decaf: baseDecaf,
        p25: baseDecaf + range * 0.25,
        p50: baseDecaf + range * 0.5,
        p75: baseDecaf + range * 0.75,
        full: fullMg
    };
}

// Get current caffeine levels based on extraction method
function getCurrentCaffeineLevels() {
    var fullMg = parseInt($("#extraction-method").val()) || 200;
    return getCaffeineLevels(fullMg);
}

// Snap a caffeine value to the nearest discrete level
function snapToCaffeineLevel(value) {
    var levels = getCurrentCaffeineLevels();
    var levelArray = [levels.decaf, levels.p25, levels.p50, levels.p75, levels.full];
    var closest = levelArray[0];
    var minDiff = Math.abs(value - closest);
    
    for (var i = 1; i < levelArray.length; i++) {
        var diff = Math.abs(value - levelArray[i]);
        if (diff < minDiff) {
            minDiff = diff;
            closest = levelArray[i];
        }
    }
    
    return closest;
}

// Snap a time value to the nearest 15-minute interval
function snapTo15Minutes(value) {
    return Math.round(value / 15) * 15;
}

// Get the label for a caffeine value
function getCaffeineLabel(value) {
    var snapped = snapToCaffeineLevel(value);
    var levels = getCurrentCaffeineLevels();
    if (snapped === levels.decaf) return 'Decaf';
    if (snapped === levels.p25) return '25%';
    if (snapped === levels.p50) return '50%';
    if (snapped === levels.p75) return '75%';
    if (snapped === levels.full) return 'Full Caf';
    return snapped + 'mg';
}

// State management for URL persistence
// Define what state to save/load - this is the single source of truth
var CALCULATOR_STATE_CONFIG = {
    wakeup: {
        get: function() { return parseInt($("#wakeup-time").val()) || 420; },
        set: function(value, skipTrigger) { 
            $("#wakeup-time").val(value);
            if (!skipTrigger) $("#wakeup-time").trigger('change');
        }
    },
    cups: {
        get: function() { return parseInt($("#cups-per-day").val()) || 5; },
        set: function(value, skipTrigger) { 
            $("#cups-per-day").val(value);
            if (!skipTrigger) $("#cups-per-day").trigger('change');
        }
    },
    sleep: {
        get: function() { return parseInt($("#sleep-time").val()) || 1320; },
        set: function(value, skipTrigger) { 
            $("#sleep-time").val(value);
            if (!skipTrigger) $("#sleep-time").trigger('change');
        }
    },
    metabolism: {
        get: function() { return parseFloat($("#metabolism").val()) || 6; },
        set: function(value, skipTrigger) { 
            $("#metabolism").val(value);
            if (!skipTrigger) $("#metabolism").trigger('change');
        }
    },
    extractionMethod: {
        get: function() { return parseInt($("#extraction-method").val()) || 200; },
        set: function(value, skipTrigger) { 
            $("#extraction-method").val(value);
            if (!skipTrigger) $("#extraction-method").trigger('change');
        }
    },
    drinks: {
        get: function() {
            if (!window.circ_config || !window.circ_config.drinks) return [];
            return window.circ_config.drinks.map(function(d) {
                return { time: d.time, mg: d.mg };
            });
        },
        set: function(value) {
            if (!value || !Array.isArray(value)) return;
            if (!window.circ_config) window.circ_config = { drinks: [] };
            window.circ_config.drinks = value.map(function(d) {
                // Allow floats in the raw dataset for both time and mg
                var parsedTime = Number(d.time);
                var parsedMg = Number(d.mg);
                return {
                    time: Number.isFinite(parsedTime) ? parsedTime : 0,
                    mg: Number.isFinite(parsedMg) ? parsedMg : 0
                };
            });
        }
    }
};

// Get current calculator state
function getCalculatorState() {
    var state = {};
    for (var key in CALCULATOR_STATE_CONFIG) {
        if (CALCULATOR_STATE_CONFIG.hasOwnProperty(key)) {
            state[key] = CALCULATOR_STATE_CONFIG[key].get();
        }
    }
    return state;
}

// Set calculator state
function setCalculatorState(state, skipTrigger) {
    if (!state) return;
    
    // Set drinks first if they exist, as other setters might trigger updates
    if (state.drinks !== undefined) {
        CALCULATOR_STATE_CONFIG.drinks.set(state.drinks);
    }
    
    // Set other state values
    for (var key in CALCULATOR_STATE_CONFIG) {
        if (CALCULATOR_STATE_CONFIG.hasOwnProperty(key) && state[key] !== undefined && key !== 'drinks') {
            CALCULATOR_STATE_CONFIG[key].set(state[key], skipTrigger);
        }
    }
}

// Serialize state to URL parameters
function serializeStateToURL(state) {
    if (!state) return;
    
    var params = new URLSearchParams();
    
    for (var key in state) {
        if (state.hasOwnProperty(key)) {
            var value = state[key];
            if (value !== null && value !== undefined) {
                if (Array.isArray(value)) {
                    // Serialize array as JSON
                    params.set(key, JSON.stringify(value));
                } else {
                    params.set(key, value.toString());
                }
            }
        }
    }
    
    var newURL = window.location.pathname;
    if (params.toString()) {
        newURL += '?' + params.toString();
    }
    
    // Update URL without page reload
    window.history.replaceState({}, '', newURL);
}

// Deserialize state from URL parameters
function deserializeStateFromURL() {
    var params = new URLSearchParams(window.location.search);
    var state = {};
    
    for (var key in CALCULATOR_STATE_CONFIG) {
        if (CALCULATOR_STATE_CONFIG.hasOwnProperty(key) && params.has(key)) {
            var value = params.get(key);
            try {
                // Try to parse as JSON (for arrays)
                if (value.startsWith('[') || value.startsWith('{')) {
                    state[key] = JSON.parse(value);
                } else {
                    // Parse as number if it's numeric (use parseFloat for metabolism, parseInt for others)
                    var numValue = (key === 'metabolism') ? parseFloat(value) : parseInt(value);
                    state[key] = isNaN(numValue) ? value : numValue;
                }
            } catch (e) {
                // If parsing fails, use as string
                state[key] = value;
            }
        }
    }
    
    return Object.keys(state).length > 0 ? state : null;
}

// Save current state to URL
function saveStateToURL() {
    var state = getCalculatorState();
    serializeStateToURL(state);
}

// Load state from URL and apply it
function loadStateFromURL() {
    var state = deserializeStateFromURL();
    if (state) {
        // Load state without triggering change events (to avoid saving back to URL)
        setCalculatorState(state, true);
        return true;
    }
    return false;
}

function update_calculator(){

        var full_mg = parseInt($("#extraction-method").val()) || 200;  // Get full caffeine value from extraction method

        var wakeup = parseInt($("#wakeup-time").val());
        var cups   = parseInt($("#cups-per-day").val());
        var sleep  = parseInt($("#sleep-time").val());
        var metabolism = parseFloat($("#metabolism").val()) || 6;  // Get metabolism value (half-life in hours)

        // spacing between cups in minutes
        var interval = 60; // next cup is always one hour away by default
        if (cups === 2) interval = 240;
        if (cups === 3) interval = 120;
        if (cups === 4) interval = 120;
        if (cups === 5) interval = 120;

        // Preserve any user‑tuned mg values when possible
        var prevCircConfig = window.circ_config || null;
        
        var circ_config = {
            drinks: [],
            halfLifeHours: metabolism,             // Use metabolism value from selector
            absorption: { type: 'easeInOut', minutes: 30 }, // gentle ramp‑in
            initialValueMg: 80
        };

        for (var i = 0; i < cups; i++){
            var baseStep = 1;
            if (cups === 5) baseStep = Math.max(1 - 0.25 * i, 0); // 100, 75, 50, 25, 0
            if (cups === 4) baseStep = Math.max(1 - 0.25 * i, 0);
            if (cups === 3) baseStep = Math.max(1 - 0.25 * i, 0);
            if (cups === 2) baseStep = Math.max(1 - 0.5  * i, 0);

            var defaultMg = full_mg * baseStep;
            var defaultTime = (wakeup + 30) + interval * i;  // first cup 30 min after wakeup
            
            // Preserve both mg and time from previous config if available
            var preservedMg = (prevCircConfig && prevCircConfig.drinks && prevCircConfig.drinks[i])
                ? prevCircConfig.drinks[i].mg
                : defaultMg;
            var preservedTime = (prevCircConfig && prevCircConfig.drinks && prevCircConfig.drinks[i])
                ? prevCircConfig.drinks[i].time
                : defaultTime;
            
            // Snap to nearest discrete caffeine level
            preservedMg = snapToCaffeineLevel(preservedMg);

            circ_config.drinks.push({
                time: preservedTime,
                mg: preservedMg
            });
        }

        window.circ_config = circ_config;
        window.circ_data   = simulateCaffeineDay(circ_config);

        var reg_config = {
            drinks: [],
            halfLifeHours: metabolism,  // Use same metabolism value
            absorption: { type: 'easeInOut', minutes: 30 },
            initialValueMg: 80
        };

        // regular schedule: constant dose each cup, but always match the circadian cup times
        for (var j = 0; j < circ_config.drinks.length; j++){
            var regTime = circ_config.drinks[j].time; // mirror circadian timing
        reg_config.drinks.push({
                time: regTime,
            mg: full_mg  
            });
        }

        window.reg_config = reg_config;
        window.reg_data   = simulateCaffeineDay(reg_config);

        // keep latest timing boundaries handy for Chart.js
        window.circ_wakeup = wakeup;
        window.circ_sleep  = sleep;
}

// Helper function to calculate Y-axis range from all datasets
function calculateYAxisRange(circSeries, regSeries, cupPoints) {
    var allValues = [];
    
    // Collect all Y values from circadian curve
    if (circSeries && circSeries.length) {
        circSeries.forEach(function(p) {
            if (typeof p.y === "number" && !isNaN(p.y)) {
                allValues.push(p.y);
            }
        });
    }
    
    // Collect all Y values from regular curve
    if (regSeries && regSeries.length) {
        regSeries.forEach(function(p) {
            if (typeof p.y === "number" && !isNaN(p.y)) {
                allValues.push(p.y);
            }
        });
    }
    
    // Collect all Y values from cup markers
    if (cupPoints && cupPoints.length) {
        cupPoints.forEach(function(p) {
            if (typeof p.y === "number" && !isNaN(p.y)) {
                allValues.push(p.y);
            }
        });
    }
    
    if (allValues.length === 0) {
        return { min: 0, max: 400 };
    }
    
    var minY = Math.min.apply(Math, allValues);
    var maxY = Math.max.apply(Math, allValues);
    
    // Add 15% padding above the max, and ensure minimum of 50mg range
    var padding = Math.max(maxY * 0.15, 20);
    var calculatedMax = maxY + padding;
    
    // Ensure minimum range for readability
    if (calculatedMax - minY < 50) {
        calculatedMax = minY + 50;
    }
    
    // Round up to nearest 75 for cleaner ticks
    calculatedMax = Math.ceil(calculatedMax / 75) * 75;
    
    return {
        min: Math.max(0, Math.floor(minY / 75) * 75), // Round down to nearest 75, but not below 0
        max: calculatedMax
    };
}

function re_render_chart(){
    if (!window.circChart) return;

    var chart = window.circChart;

    // dataset[0]: Circadian program curve
    // dataset[1]: Full caffeine curve
    // dataset[2]: Draggable cup markers

    var circSeries = (window.circ_data || []).map(function(p){
        return { x: p.time, y: p.value };
    });
    var regSeries = (window.reg_data || []).map(function(p){
        return { x: p.time, y: p.value };
    });
    var cupPoints = (window.circ_config && window.circ_config.drinks || []).map(function(d, idx){
        return { x: d.time + 30, y: snapToCaffeineLevel(d.mg), cupIndex: idx };
    });

    if (chart.data.datasets[0]) chart.data.datasets[0].data = circSeries;
    if (chart.data.datasets[1]) chart.data.datasets[1].data = regSeries;
    if (chart.data.datasets[2]) chart.data.datasets[2].data = cupPoints;

    // Update X-axis range
    if (chart.options && chart.options.scales && chart.options.scales.x) {
        var minX = (typeof window.circ_wakeup === "number" ? window.circ_wakeup - 60 : 0);
        var maxX = (typeof window.circ_sleep === "number" ? window.circ_sleep + 120 : 1440);
        chart.options.scales.x.min = Math.max(0, minX);
        chart.options.scales.x.max = Math.min(1440, maxX);
    }
    
    // Update Y-axis range dynamically (left axis - only for curves, not cup markers)
    if (chart.options && chart.options.scales && chart.options.scales.y) {
        var yRange = calculateYAxisRange(circSeries, regSeries, []);  // Don't include cup markers
        chart.options.scales.y.min = yRange.min;
        chart.options.scales.y.max = yRange.max;
    }
    
    // Update right Y-axis range dynamically (for cup markers)
    if (chart.options && chart.options.scales && chart.options.scales.y1) {
        // Right axis always shows full range of discrete levels with padding
        var levels = getCurrentCaffeineLevels();
        chart.options.scales.y1.max = levels.full + 30;  // Add padding at top
        chart.options.scales.y1.min = -20;  // Add padding at bottom
    }

    chart.update('none');
}

// New Chart.js based caffeine chart using chartjs-plugin-dragdata
function display_chart_chartjs(){

    update_calculator();

    var canvas = document.getElementById("circadianChart");
    if (!canvas || typeof Chart === "undefined") {
        console.warn("Circadian chart: Chart.js not available or canvas missing.");
        return;
    }

    var ctx = canvas.getContext("2d");
    var isMobile = window.matchMedia && window.matchMedia("(max-width: 768px)").matches;

    var circSeries = (window.circ_data || []).map(function(p){
        return { x: p.time, y: p.value };
    });
    var regSeries = (window.reg_data || []).map(function(p){
        return { x: p.time, y: p.value };
    });
    var cupPoints = (window.circ_config && window.circ_config.drinks || []).map(function(d, idx){
        return { x: d.time + 30, y: snapToCaffeineLevel(d.mg), cupIndex: idx };
    });

    var wakeup = window.circ_wakeup || 420;
    var sleep  = window.circ_sleep  || 1320;
    
    // Calculate dynamic Y-axis range (left axis - only for curves, not cup markers)
    var yRange = calculateYAxisRange(circSeries, regSeries, []);  // Don't include cup markers

    // Custom plugin to draw vertical lines through each cup marker
    var cupLinesPlugin = {
        id: 'cupLinesPlugin',
        afterDatasetsDraw: function(chart) {
            if (!chart || !chart.data || !chart.data.datasets || !chart.data.datasets[2]) return;
            var cupDataset = chart.data.datasets[2];
            var meta = chart.getDatasetMeta(2);
            if (!meta || !meta.data || meta.data.length === 0) return;
            var ctx = chart.ctx;
            var xScale = chart.scales.x;
            if (!xScale) return;
            var top = chart.chartArea.top;
            var bottom = chart.chartArea.bottom;

            ctx.save();
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'rgba(200,200,200,0.35)';

            meta.data.forEach(function(point) {
                if (!point || typeof point.x !== 'number') return;
                var x = point.x;
                ctx.beginPath();
                ctx.moveTo(x, top);
                ctx.lineTo(x, bottom);
                ctx.stroke();
            });

            ctx.restore();
        }
    };

    // Custom plugin to render always-visible tooltips after datasets are drawn
    var cupTooltipPlugin = {
        id: 'cupTooltipPlugin',
        afterDatasetsDraw: function(chart) {
            renderCupTooltips();
        }
    };

    // Build the Chart.js instance with dragdata for cup markers
    window.circChart = new Chart(ctx, {
        type: "line",
        plugins: [cupLinesPlugin, cupTooltipPlugin],
        data: {
            datasets: [
                {
                    label: "Circadian Program",
                    data: circSeries,
                    borderColor: "#FFFFFF",  // white line
                    borderWidth: 2,
                    tension: 1,
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    pointHitRadius: 0,
                    pointStyle: "line",
                    fill: false,
                    parsing: false,
                    order: 99,  // Draw first (behind)
                    tooltip: {
                        enabled: false
                    }
                },
                {
                    label: "Regular Coffee",
                    data: regSeries,
                    borderColor: "#444444",  // gray dotted line
                    borderWidth: 1.5,
                    borderDash: [4, 4],
                    tension: 0,
                    pointRadius: 0,
                    pointHoverRadius: 0,
                    pointHitRadius: 0,
                    pointStyle: "line",
                    fill: false,
                    parsing: false,
                    order: 99,  // Draw second (middle)
                    tooltip: {
                        enabled: false
                    }
                },
                {
                    label: "Your Cups",
                    data: cupPoints,
                    borderColor: "rgba(0,0,0,0)",
                    backgroundColor: "#F4AD6A",  // orange dots
                    pointRadius: 10,
                    pointHoverRadius: 12,
                    pointHitRadius: (typeof window.cupDraggingEnabled !== 'undefined' && window.cupDraggingEnabled) ? 60 : 0,  // Much larger hit area for easier dragging, or 0 when locked
                    pointStyle: "circle",
                    showLine: false,
                    dragData: (typeof window.cupDraggingEnabled !== 'undefined' && window.cupDraggingEnabled) ? true : false,  // Enable/disable based on initial state
                    yAxisID: "y1",  // Use separate Y-axis on the right
                    order: 0  // Draw last (on top)
                }
            ]
        },
        options: {
            parsing: false,
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 0  // Disable all animations completely
            },
            transitions: {
                active: {
                    animation: {
                        duration: 0  // Disable transitions during interactions
                    }
                }
            },
            onHover: function(event, activeElements) {
                var chart = window.circChart;
                if (!chart || !chart.canvas) return;
                
                // Check if hovering over a cup marker (dataset index 2) and dragging is enabled
                if (window.cupDraggingEnabled && activeElements && activeElements.length > 0) {
                    var isCupMarker = activeElements.some(function(element) {
                        return element.datasetIndex === 2;
                    });
                    if (isCupMarker) {
                        chart.canvas.style.cursor = 'grab';
                        return;
                    }
                }
                chart.canvas.style.cursor = 'default';
            },
            interaction: {
                mode: "nearest",
                intersect: true
            },
            plugins: {
                legend: {
                    position: "top",
                    onClick: function() {
                        // Disable legend clicks - series visibility should not be toggleable
                        return false;
                    },
                    labels: {
                        color: "#ffffff",
                        usePointStyle: true,
                        boxWidth: 10,
                        padding: 20  // Horizontal spacing between legend items
                    }
                },
                tooltip: {
                    enabled: false  // Disable default tooltips, we'll use custom always-visible ones
                },
                dragData: {
                    round: 0,
                    showTooltip: false,  // Disable dragData tooltip, use Chart.js tooltip instead
                    dragX: true,  // Enable horizontal dragging for time adjustment
                    magnet: {
                        to: function(value) {
                            // Only snap Y values (caffeine), not X values (time)
                            // The plugin passes the value being dragged, which for vertical drags is Y
                            return snapToCaffeineLevel(value);
                        }
                    },
                    onDragStart: function(event, datasetIndex, index, value) {
                        // Only allow dragging if enabled and on the cup markers dataset
                        if (!window.cupDraggingEnabled) {
                            return false;
                        }
                        if (datasetIndex === 2) {
                            var chart = window.circChart;
                            if (chart && chart.canvas) {
                                chart.canvas.style.cursor = 'grabbing';
                            }
                            return true;
                        }
                        return false;
                    },
                    onDrag: function(event, datasetIndex, index, value) {
                        if (!window.cupDraggingEnabled) return false;
                        if (datasetIndex !== 2) return false;
                        
                        // Get the current data point from the chart to check both X and Y
                        var chart = window.circChart;
                        if (!chart || !chart.data || !chart.data.datasets || !chart.data.datasets[datasetIndex]) {
                            return false;
                        }
                        
                        var dataPoint = chart.data.datasets[datasetIndex].data[index];
                        if (!dataPoint) return false;
                        
                        // value is the Y value being dragged to
                        var newY = typeof value === 'number' ? value : (dataPoint.y || 0);
                        var newX = dataPoint.x || 0;
                        
                        // Snap X (time) values to 15-minute intervals
                        newX = snapTo15Minutes(newX);
                        // Clamp X to valid day range and update data point
                        newX = Math.max(0, Math.min(1439, newX));
                        if (dataPoint.x !== newX) {
                            dataPoint.x = newX;
                        }
                        
                        // Snap Y (caffeine) values to discrete levels
                        newY = snapToCaffeineLevel(newY);
                        
                        // Update the data point with snapped value (magnet should handle this, but ensure it)
                        if (dataPoint.y !== newY) {
                            dataPoint.y = newY;
                        }
                        
                        // Clamp Y (caffeine) values to valid range
                        var levels = getCurrentCaffeineLevels();
                        if (newY < levels.decaf || newY > levels.full) return false;
                        
                        // Clamp X (time) values to valid day range (0-1439 minutes)
                        if (newX < 0 || newX > 1439) return false;
                        
                        // Update in real-time during drag
                        if (!window.circ_config || !window.circ_config.drinks || !window.circ_config.drinks[index]) {
                            return true;
                        }
                        
                        var drink = window.circ_config.drinks[index];
                        var updated = false;
                        
                        // Update caffeine level (Y-axis) - use snapped value
                        var newMg = snapToCaffeineLevel(newY);
                        if (Math.abs(drink.mg - newMg) > 0.5) {
                            drink.mg = newMg;
                            updated = true;
                        }
                        
                        // Update time (X-axis) - note: cupPoints use time + 30, so we need to adjust
                        // newX is already snapped to 15-minute intervals above
                        var newTime = newX; // Already clamped and snapped
                        // The cup point is displayed at time + 30 (peak absorption), so adjust back
                        var actualDrinkTime = newTime - 30;
                        if (Math.abs(drink.time - actualDrinkTime) > 0.5) {
                            drink.time = actualDrinkTime;
                            updated = true;
                            
                            // Also update the regular schedule to match the new time
                            if (window.reg_config && window.reg_config.drinks && window.reg_config.drinks[index]) {
                                window.reg_config.drinks[index].time = actualDrinkTime;
                            }
                        }
                        
                        if (updated) {
                            // Recalculate both curves with updated times/amounts
                            window.circ_data = simulateCaffeineDay(window.circ_config);
                            if (window.reg_config) {
                                window.reg_data = simulateCaffeineDay(window.reg_config);
                            }
                            
                            // Update chart datasets in real-time
                            var circSeries = (window.circ_data || []).map(function(p){
                                return { x: p.time, y: p.value };
                            });
                            var regSeries = (window.reg_data || []).map(function(p){
                                return { x: p.time, y: p.value };
                            });
                            
                            if (chart.data.datasets[0]) chart.data.datasets[0].data = circSeries;
                            if (chart.data.datasets[1]) chart.data.datasets[1].data = regSeries;
                            
                            // Update Y-axis range if needed (left axis - only for curves, not cup markers)
                            if (chart.options && chart.options.scales && chart.options.scales.y) {
                                var yRange = calculateYAxisRange(circSeries, regSeries, []);  // Don't include cup markers
                                chart.options.scales.y.min = yRange.min;
                                chart.options.scales.y.max = yRange.max;
                            }
                            
                            // Update right Y-axis range dynamically (for cup markers)
                            if (chart.options && chart.options.scales && chart.options.scales.y1 && chart.data.datasets[2]) {
                                // Right axis always shows full range of discrete levels with padding
                                var levels = getCurrentCaffeineLevels();
                                chart.options.scales.y1.max = levels.full + 30;  // Add padding at top
                                chart.options.scales.y1.min = -20;  // Add padding at bottom
                            }
                            
                            // Update chart without animation for smooth real-time updates
                            chart.update('none');
                            
                            // Don't update tooltips during drag - they'll be updated on drag end
                            // This prevents the marker from disappearing during drag
                        }
                        
                        return true;
                    },
                    onDragEnd: function(event, datasetIndex, index, value) {
                        // Final update to ensure everything is in sync
                        if (datasetIndex !== 2) return;
                        
                        // Change cursor back to grab (will be updated by onHover if still over a cup marker)
                        var chart = window.circChart;
                        if (chart && chart.canvas) {
                            chart.canvas.style.cursor = 'grab';
                        }
                        
                        // Trigger a final update to ensure everything is properly synced
                        setTimeout(function() {
                            if (window.circChart && window.circ_config) {
                                re_render_chart();
                                // Update tooltips after final render
                                requestAnimationFrame(function() {
                                    renderCupTooltips();
                                });
                                saveStateToURL();
                                selectByobOption(true); // Suppress scroll when triggered by calculator changes
                                selectCustomCaffeine(); // Mark caffeine as custom
                            }
                        }, 0);
                    }
                }
            },
            scales: {
                x: {
                    type: "linear",
                    min: Math.max(0, wakeup - 60),
                    max: Math.min(1440, sleep + 120),
                    grid: {
                        color: "rgba(255,255,255,0.08)"
                    },
                    ticks: {
                        display: !isMobile,
                        color: "#AAAAAA",
                        maxTicksLimit: 8,
                        callback: function(value) {
                            return minutesTo12h(value);
                        }
                    },
                    title: {
                        display: !isMobile,
                        text: "Time of Day",
                        color: "#7E7E7E"
                    }
                },
                y: {
                    position: "right",
                    beginAtZero: true,
                    min: yRange.min,
                    max: yRange.max,
                    grid: {
                        color: "rgba(255,255,255,0.08)"
                    },
                    ticks: {
                        display: !isMobile,
                        color: "#aaaaaa",
                        stepSize: 75  // Round tick marks for cleaner display
                    },
                    title: {
                        display: !isMobile,
                        text: "Estimated Caffeine (mg)",
                        color: "#aaaaaa"
                    }
                },
                y1: {
                    position: "left",
                    beginAtZero: false,
                    min: -20,  // Add padding at bottom
                    max: (function() {
                        var levels = getCurrentCaffeineLevels();
                        return levels.full + 30;  // Add padding at top
                    })(),
                    grid: {
                        display: false  // Don't show grid lines for the right axis
                    },
                    ticks: {
                        display: !isMobile,
                        color: "#aaaaaa",
                        maxRotation: 90,
                        minRotation: 90,
                        // Force ticks to match discrete cup strengths
                        callback: function(value) {
                            var levels = getCurrentCaffeineLevels();
                            var levelArray = [levels.decaf, levels.p25, levels.p50, levels.p75, levels.full];
                            var epsilon = 0.5;
                            for (var i = 0; i < levelArray.length; i++) {
                                if (Math.abs(value - levelArray[i]) < epsilon) {
                                    return getCaffeineLabel(levelArray[i]);
                                }
                            }
                            return '';
                        },
                        // Let Chart.js place ticks, but we'll override to ensure our discrete set
                        stepSize: undefined
                    },
                    afterBuildTicks: function(scale) {
                        var levels = getCurrentCaffeineLevels();
                        scale.ticks = [
                            { value: levels.decaf },
                            { value: levels.p25 },
                            { value: levels.p50 },
                            { value: levels.p75 },
                            { value: levels.full }
                        ];
                    },
                    title: {
                        display: !isMobile,
                        text: "Cup Strength (mg)",
                        color: "#aaaaaa"
                    }
                }
            }
        }
    });
    
    // Create always-visible tooltips for cup markers after chart is fully rendered
    // Use requestAnimationFrame to ensure chart is fully drawn and state is initialized
    requestAnimationFrame(function() {
        // Ensure dragging state is initialized before rendering
        if (typeof window.cupDraggingEnabled === 'undefined') {
            window.cupDraggingEnabled = true;
        }
        renderCupTooltips();
    });
}

// Function to render always-visible tooltips for cup markers
function renderCupTooltips() {
    if (!window.circChart) return;
    
    var chart = window.circChart;
    var chartContainer = document.getElementById('chartdiv');
    if (!chartContainer) return;
    
    // Ensure chart container has relative positioning
    var containerStyle = window.getComputedStyle(chartContainer);
    if (containerStyle.position === 'static') {
        chartContainer.style.position = 'relative';
    }
    
    // Remove existing tooltips and drag indicators
    var existingTooltips = chartContainer.querySelectorAll('.cup-tooltip');
    existingTooltips.forEach(function(tooltip) {
        tooltip.remove();
    });
    var existingIndicators = chartContainer.querySelectorAll('.drag-indicator');
    existingIndicators.forEach(function(indicator) {
        indicator.remove();
    });
    
    // Get cup markers dataset
    var cupDataset = chart.data.datasets[2];
    if (!cupDataset || !cupDataset.data) return;
    
    // Build a rank map based on time of day (earliest cup = 1)
    var cupOrder = cupDataset.data
        .map(function(dp, idx) {
            if (!dp || typeof dp.x !== 'number') return null;
            return { idx: idx, time: dp.x };
        })
        .filter(Boolean)
        .sort(function(a, b) {
            if (a.time === b.time) return a.idx - b.idx;
            return a.time - b.time;
        });
    var cupRankMap = {};
    cupOrder.forEach(function(item, pos) {
        cupRankMap[item.idx] = pos + 1; // Cup numbers start at 1
    });
    
    // Get chart area and scales
    var chartArea = chart.chartArea;
    if (!chartArea || chartArea.left === undefined) {
        // Chart not fully rendered yet, try again on next frame
        requestAnimationFrame(function() {
            renderCupTooltips();
        });
        return;
    }
    
    var xScale = chart.scales.x;
    var yScale = chart.scales.y1; // Use y1 scale for cup markers
    
    // Get dataset meta for accurate positioning
    var meta = chart.getDatasetMeta(2);
    if (!meta || !meta.data || meta.data.length === 0) {
        // Meta not ready yet, try again on next frame
        requestAnimationFrame(function() {
            renderCupTooltips();
        });
        return;
    }
    
    // Create tooltip for each cup marker
    cupDataset.data.forEach(function(dataPoint, index) {
        if (!dataPoint || typeof dataPoint.x !== 'number' || typeof dataPoint.y !== 'number') return;
        if (!meta.data[index]) return;
        
        // Get pixel position from the point element
        var point = meta.data[index];
        var x = point.x;
        var y = point.y;
        
        // Convert to container-relative coordinates using bounding rects
        var canvasRect = chart.canvas.getBoundingClientRect();
        var containerRect = chartContainer.getBoundingClientRect();
        var relX = x + canvasRect.left - containerRect.left;
        var relY = y + canvasRect.top - containerRect.top;
        
        // Verify positions are valid numbers
        if (typeof relX !== 'number' || typeof relY !== 'number' || isNaN(relX) || isNaN(relY)) {
            return;
        }
        
        // Create tooltip element
        var tooltip = document.createElement('div');
        tooltip.className = 'cup-tooltip';
        tooltip.style.position = 'absolute';
        tooltip.style.left = relX + 'px';
        tooltip.style.top = (relY - 60) + 'px'; // Position above the marker, a bit higher
        tooltip.style.backgroundColor = 'rgba(0,0,0,0.15)'; // subtle overlay
        tooltip.style.backdropFilter = 'blur(2px)'; // soft blur
        tooltip.style.WebkitBackdropFilter = 'blur(2px)';
        tooltip.style.color = '#ffffff';
        tooltip.style.padding = '6px 10px';
        tooltip.style.borderRadius = '4px';
        tooltip.style.fontSize = '12px';
        tooltip.style.pointerEvents = 'none';
        tooltip.style.zIndex = '1000';
        tooltip.style.whiteSpace = 'nowrap';
        tooltip.style.transform = 'translateX(-50%)'; // Center horizontally
        tooltip.style.fontFamily = 'inherit';
        
        // Get tooltip content
        var time = dataPoint.x;
        var mg = dataPoint.y;
        var label = getCaffeineLabel(mg);
        var cupNumber = cupRankMap[index] || (index + 1);
        
        tooltip.innerHTML = '<div><strong>Cup ' + cupNumber + '</strong></div><div>' + minutesTo12h(time) + '</div><div>' + label + '</div>';
        
        chartContainer.appendChild(tooltip);
        
        // Create drag indicator (2x3 grid of dots) next to the marker - only if dragging is enabled
        if (window.cupDraggingEnabled) {
            var dragIndicator = document.createElement('div');
            dragIndicator.className = 'drag-indicator';
            dragIndicator.style.position = 'absolute';
            dragIndicator.style.left = (relX + 18) + 'px'; // Position to the right of the marker
            dragIndicator.style.top = (relY - 9) + 'px'; // Center vertically with the marker
            dragIndicator.style.width = '12px';
            dragIndicator.style.height = '18px';
            dragIndicator.style.display = 'flex';
            dragIndicator.style.flexDirection = 'column';
            dragIndicator.style.gap = '3px';
            dragIndicator.style.pointerEvents = 'none';
            dragIndicator.style.zIndex = '999';
            
            // Create 2x3 grid (2 columns, 3 rows = 6 dots)
            for (var row = 0; row < 3; row++) {
                var rowContainer = document.createElement('div');
                rowContainer.style.display = 'flex';
                rowContainer.style.gap = '3px';
                rowContainer.style.justifyContent = 'center';
                
                for (var col = 0; col < 2; col++) {
                    var dot = document.createElement('div');
                    dot.style.width = '3px';
                    dot.style.height = '3px';
                    dot.style.borderRadius = '50%';
                    dot.style.backgroundColor = '#ffffff';
                    dot.style.opacity = '0.6';
                    rowContainer.appendChild(dot);
                }
                
                dragIndicator.appendChild(rowContainer);
            }
            
            chartContainer.appendChild(dragIndicator);
        }
    });
}


function minutesTo12h(min) {
  min = Math.round(min);
  const h24 = Math.floor(min / 60);
  const m = min % 60;
  const suffix = h24 >= 12 ? "PM" : "AM";
  let h12 = h24 % 12;
  if (h12 === 0) h12 = 12;
  return `${h12}:${String(m).padStart(2, "0")} ${suffix}`;
}


/**
 * Simulate caffeine over one calendar day at 1-minute resolution.
 * Output: [{ time: minuteIndex(0..1439), value: mgInSystem }]
 *
 * Minute update:
 *   x_{t+1} = (x_t + bolus_t) * e^{-k} + infusionRate_t * ((1 - e^{-k}) / k)
 * where k = ln(2) / halfLifeMinutes.
 *
 * Absorption modes:
 * - instant  entire dose as a bolus at the start minute
 * - linear   dose spread evenly over N minutes
 * - easeOut  dose spread over N minutes using F(u) = 1 - (1 - u)^p
 * - easeInOut dose spread over N minutes using a symmetric power S-curve:
 *             F(u) = 0.5*(2u)^p for u < 0.5, and F(u) = 1 - 0.5*(2*(1-u))^p for u >= 0.5
 *
 * @param {Object} opts
 * @param {{ time: string|number, mg: number }[]} opts.drinks
 * @param {number} [opts.halfLifeHours=5]
 * @param {{ type: 'instant'|'linear'|'easeOut'|'easeInOut', minutes?: number, power?: number }} [opts.absorption]
 * @param {number} [opts.initialValueMg=0]
 * @returns {{time:number, value:number}[]}
 */
function simulateCaffeineDay({
  drinks = [],
  halfLifeHours = 5,
  absorption = { type: 'linear', minutes: 30 },
  initialValueMg = 0
} = {}) {
  const MINUTES_PER_DAY = 1440;

//   // Parse "HH:MM" or minutes since midnight.
//   const toMinuteIndex = t => {
//     if (typeof t === 'number' && Number.isFinite(t)) {
//       return Math.max(0, Math.min(MINUTES_PER_DAY - 1, Math.floor(t)));
//     }
//     if (typeof t === 'string') {
//       const [hh, mm] = t.split(':').map(n => parseInt(n, 10));
//       if (
//         Number.isFinite(hh) && Number.isFinite(mm) &&
//         hh >= 0 && hh <= 23 && mm >= 0 && mm <= 59
//       ) return hh * 60 + mm;
//     }
//     throw new Error(`Invalid time value: ${t}`);
//   };

  // Kinetics
  const halfLifeMins = Math.max(0, Number(halfLifeHours) || 0) * 60;
  const k = halfLifeMins > 0 ? Math.LN2 / halfLifeMins : 0; // per minute
  const decay = k > 0 ? Math.exp(-k) : 1;                   // e^{-k}
  const infusionGain = k > 0 ? (1 - decay) / k : 1;

  // Schedules
  const bolus = new Array(MINUTES_PER_DAY).fill(0);     // mg at start of minute
  const infusion = new Array(MINUTES_PER_DAY).fill(0);  // mg per minute across minute

  // Helper CDFs for distributing a dose across minutes
  const easeOutCDF = (u, p = 3) => 1 - Math.pow(1 - u, Math.max(1, p));
  const easeInOutCDF = (u, p = 3) => {
    const pp = Math.max(1, p);
    if (u <= 0) return 0;
    if (u >= 1) return 1;
    if (u < 0.5) {
      return 0.5 * Math.pow(2 * u, pp);
    } else {
      return 1 - 0.5 * Math.pow(2 * (1 - u), pp);
    }
  };

  // Distribute mg over integer minutes using any monotone CDF F on [0,1]
  function distributeByCDF(t0, mg, minutes, F) {
    const span = Math.max(1, Math.floor(minutes));
    for (let i = 0; i < span; i++) {
      const u0 = i / span;
      const u1 = (i + 1) / span;
      const w = F(u1) - F(u0); // mass in minute i
      const idx = t0 + i;
      if (idx >= 0 && idx < MINUTES_PER_DAY) {
        // Treat as a constant rate during this minute
        infusion[idx] += mg * w; // mg/min over a 1-minute interval
      }
    }
  }

  for (const d of drinks) {
    const mg = Number(d.mg);
    if (!Number.isFinite(mg) || mg <= 0) continue;

    const t0 = d.time //toMinuteIndex(d.time);
    const type = absorption?.type || 'linear';

    if (type === 'instant') {
      bolus[t0] += mg;
    } else if (type === 'linear') {
      const span = Math.max(1, Math.floor(absorption?.minutes ?? 30));
      const perMin = mg / span;
      for (let i = 0; i < span; i++) {
        const idx = t0 + i;
        if (idx >= 0 && idx < MINUTES_PER_DAY) infusion[idx] += perMin;
      }
    } else if (type === 'easeOut') {
      const span = Math.max(1, Math.floor(absorption?.minutes ?? 30));
      const p = absorption?.power ?? 3;
      distributeByCDF(t0, mg, span, u => easeOutCDF(u, p));
    } else if (type === 'easeInOut') {
      const span = Math.max(1, Math.floor(absorption?.minutes ?? 30));
      const p = absorption?.power ?? 3;
      distributeByCDF(t0, mg, span, u => easeInOutCDF(u, p));
    } else {
      throw new Error(`Unknown absorption type: ${type}`);
    }
    // Spill past midnight is ignored for this single-day simulation
  }

  // Simulate
  const result = new Array(MINUTES_PER_DAY);
  let value = Math.max(0, Number(initialValueMg) || 0);

  for (let m = 0; m < MINUTES_PER_DAY; m++) {
    value = (value + bolus[m]) * decay + infusion[m] * infusionGain;
    result[m] = { time: m, value: Math.round(value) };
  }

  return result;
}




